import React, { lazy } from 'react';
import { Outlet, Route } from 'react-router-dom';

import PageLayout from '~/components/PageLayout';
import { Head, PrivateRoute, Snackbar } from '~/components/common';
import {
  GAMES,
  INVITE,
  LOGIN,
  PLAYERS,
  REFEREES,
  ROOT,
  SETTINGS_ADMINS,
  SETTINGS_GROUPS,
  SETTINGS_POSITIONS,
  SETTINGS_TOUR_TYPES,
  TEAMS,
  TOURNAMENTS,
} from '~/constants/routes';

import { Invite } from './components/pages/Invite';
import { ThemeWrapper } from './theme';

const privatePage = (page: React.ReactNode) => <PrivateRoute>{page}</PrivateRoute>;

const Referees = lazy(() => import('~/components/pages/Referees'));
const Players = lazy(() => import('~/components/pages/Players'));
const Tournaments = lazy(() => import('~/components/pages/Tournaments'));
const Teams = lazy(() => import('~/components/pages/Teams'));
const Games = lazy(() => import('~/components/pages/Games'));
const Admins = lazy(() => import('~/components/pages/Settings/Admins'));
const Groups = lazy(() => import('~/components/pages/Settings/Groups'));
const Positions = lazy(() => import('~/components/pages/Settings/Positions'));
const TourTypes = lazy(() => import('~/components/pages/Settings/Tours'));
const Welcome = lazy(() => import('~/components/pages/Welcome'));
const Login = lazy(() => import('~/components/pages/Login'));

export const Routes = (
  <>
    <Route path={ROOT} element={<PageLayout />}>
      <Route path={ROOT} element={privatePage(<Welcome />)} />
      <Route path={`${TOURNAMENTS}/*`} element={privatePage(<Tournaments />)} />
      <Route path={PLAYERS} element={privatePage(<Players />)} />
      <Route path={REFEREES} element={privatePage(<Referees />)} />
      <Route path={TEAMS} element={privatePage(<Teams />)} />
      <Route path={GAMES} element={privatePage(<Games />)} />
      <Route path={SETTINGS_ADMINS} element={privatePage(<Admins />)} />
      <Route path={SETTINGS_GROUPS} element={privatePage(<Groups />)} />
      <Route path={SETTINGS_POSITIONS} element={privatePage(<Positions />)} />
      <Route path={SETTINGS_TOUR_TYPES} element={privatePage(<TourTypes />)} />
    </Route>
    <Route
      path={LOGIN}
      element={
        <ThemeWrapper>
          <Snackbar />
          <Head />
          <Outlet />
        </ThemeWrapper>
      }
    >
      <Route index element={<Login />} />
    </Route>
    <Route
      path={INVITE}
      element={
        <ThemeWrapper>
          <Snackbar />
          <Head />
          <Outlet />
        </ThemeWrapper>
      }
    >
      <Route index element={<Invite />} />
    </Route>
  </>
);
